import React from "react";
import styles from "./textModal.module.scss";
import { copyToClipboard } from "../../../../utils/copyToClipboard";
import { useCustomSnackbar } from "../../../../utils/hooks/useCustomSnackbar";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

export const TextModal = ({ data }) => {
  const { addDefaultSnack } = useCustomSnackbar();

  const triggerCopy = isCopied => {
    isCopied && addDefaultSnack("Скопировано");
  };
  return (
    <div className={styles.modal}>
      <h1 className={styles.modal__title}>{data?.title || ""}</h1>
      {!!data?.addInfo && (
        <p className={styles.modal__addInfo}>{data?.addInfo}</p>
      )}
      <p
        className={styles.modal__description}
        title={data?.copy ? "Скопировать" : ""}
      >
        {data?.description}
        {!!data?.value && (
          <span
            className={data?.copy ? styles.modal__copy : ""}
            onClick={() =>
              data?.copy && copyToClipboard(data?.value, triggerCopy)
            }
          >
            <span>{data?.value}</span>
            {data?.copy && <FileCopyOutlinedIcon className={styles.modal__icon} />}
          </span>
        )}
      </p>
    </div>
  );
};
